<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input-legacy label="labour"
                         [field]="model.labour_name"
                         type="input"
                         typevar="rbg"
                         [optionfunc]="goToSelectLabour"
                         glyphs="glyphicon-search">
        </tt-input-legacy>

        <tt-input-legacy label="location"
                         [field]="model.stocklocation_name"
                         type="input"
                         typevar="rbg"
                         [optionfunc]="goToSelectLocation"
                         glyphs="glyphicon-search">
        </tt-input-legacy>
    </tt-card>

    <tt-list-legacy class="col-xs-12 col-md-12 p-5"
                    [listItems]="model.consignments"
                    ltype="multi"
                    [mconfig]="model.mconfig"
                    designVar="s12"
                    typevar="g">
    </tt-list-legacy>
</tt-page>
